import { HierarchyContextProps, IHierarchyActionUpdateDomainReplacement } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Updates a domain replacement in the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The update-domain-replacement action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_updateDomainReplacement = (
  state: HierarchyContextProps,
  action: IHierarchyActionUpdateDomainReplacement,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const ix = state.hierarchy.domainReplacements.findIndex(
    (dr) => dr.airid === action.domainReplacement.airid,
  );
  if (ix > -1) {
    return hcr_updateChangedFlag(
      {
        ...state,
        hierarchy: {
          ...state.hierarchy,
          domainReplacements: state.hierarchy.domainReplacements.map((dr) =>
            dr.airid === action.domainReplacement.airid ? action.domainReplacement : dr,
          ),
        },
      },
      action,
    );
  }

  return state;
};
